module.exports = __webpack_public_path__ + "img/RenataInsta_Final.c67cf17c.jpg";